import { Design } from '@/types';

export const isUploadedDesign = (design: Design) => Boolean(design?.customerUpload);
